__turbopack_context__.v({
  "bubble": "_95filW_bubble",
  "card": "_95filW_card",
  "flight": "_95filW_flight",
  "image": "_95filW_image",
  "polaroid": "_95filW_polaroid",
  "stage": "_95filW_stage",
});
